import React, {Fragment} from "react";
import {ActionType} from "../list/list/DataTable";
import {CasinoStudio, ListCasinoLobbyCategoryRequest, ListChartsRequest, ListStudioRequest} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {EntityDataTable} from "../list/list/EntityDataTable";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {withRouter} from "react-router";
import {ListView, ListViewProps, ListViewState} from "../ListView";
import {Form, FormListener} from "../form/Form";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {Submit} from "../form/Submit";
import {CasinoStudioService} from "../../services/CasinoStudioService";


interface State extends ListViewState<ListCasinoLobbyCategoryRequest> {
    form? : ListStudioRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {

}

export class CasinoCategoryListView extends ListView<State, ListChartsRequest> implements FormListener<ListStudioRequest>{

    columns = [
        { property : "id", name : "ID", orderBy : "id"},
        { property : "name", name : "Name"},
        { property : "lobbyOrder", name : "Lobby Order", orderBy : "lobbyOrder"},
        { property : "integration", name : "Integration"},
        { property : "enabled", name : "Enabled", renderer : (p : string,n : string,i : any) => i[p] == true ? "Yes" : "No"},
        { property : "externalId", name : "External ID"}
    ];

    actions = [
        { id : "view", name : "Edit", className : "btn btn-primary", iconClassName : "fa fa-edit", type : ActionType.LINK, getLink : (item : any) => "/casino-studio/" + item.id }

    ];

    service : CasinoStudioService;

    constructor(props : Props){
        super(props, "/casino-studios");
        this.state = {...this.state,  listRequest : {...this.state.listRequest, orderBy : "lobbyOrder", ascending : false}, validationMap : {}, form : {}};
        this.service = getContainer().getCasinoStudioService();
    }
    onSubmit() : void | Promise<any> {
        if(this.state.form) {
            let form = this.state.form;
            form.offset = 0;
            this.updateListState(form);
        }
    }
    onSubmitError() :  void {

    }

    formDidUpdate(formModel: ListStudioRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }

    onAction(item : CasinoStudio, action : string) : Promise<any> | undefined {
        return;
    }

    pagerChanged(pager : PagerModel) {
        if(this.state.listRequest) {
            console.log("pager changed!", pager);
            let listRequest = ListUtils.toListRequest<any>(this.state.listRequest,pager);
            this.updateListState(listRequest);
        }
    }
    getTitle() {
        return "Casino Game Studios"
    }

    renderContent() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return (
            <Fragment>
                <div className={"card-box"}>
                    <h4>Search Filters</h4>
                    <Form formListener={this} modelObject={this.state.form} validationMap={this.state.validationMap}>
                        <FormGroup className={"form-group"}>
                            <label>Name</label>
                            <FormInput model={"name"} className={"form-control"} validators={[Validators.strLength(1,255)]}/>
                            <span className={"help-text"}>Search by name</span>
                        </FormGroup>
                        <Submit className={"btn btn-primary"}>Search</Submit>
                    </Form>
                </div>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}/>
            </Fragment>
        );
    }



}

export default withRouter(CasinoCategoryListView);
